class SaaSSubscription {
    static getSearchKey() {
        return 'subscriptionId';
    }

    static fromRaw(raw) {
        let saasSubscription = new SaaSSubscription();
        saasSubscription.uuid = raw.uuid;
        saasSubscription.name = raw.name;
        saasSubscription.state = raw.state;
        saasSubscription.planId = raw.planId;
        saasSubscription.status = raw.status;
        saasSubscription.subscriptionUuid = raw.subscriptionUuid;
        saasSubscription.subscriptionName = raw.subscriptionName;
        saasSubscription.customer = raw.customer;
        saasSubscription.term = raw.term;
        saasSubscription.freeTrial = raw.freeTrial;
        return saasSubscription;
    }
}

module.exports = SaaSSubscription;



// WEBPACK FOOTER //
// ./src/azurebackup/model/SaaSSubscription.js